import { ReactElement, useEffect, useRef } from 'react'

import Spinner from '../../components/spinner/Spinner'
import { useQueryParams } from '../../hooks/useQueryParams'

import useAuth from '../../utils/auth/useAuth'
import { getAzureLocales } from '../../utils/azure'
import { SpinnerContainer } from '../showroom/vehicle-list/VehicleList.styled'

const PasswordReset = (): ReactElement => {
  const { isLoading, passwordResetRedirect } = useAuth()
  const queryParams = useQueryParams()
  const started = useRef(false)
  const language = queryParams.get('language')

  useEffect(() => {
    if (!isLoading && passwordResetRedirect && !started.current) {
      started.current = true
      passwordResetRedirect(getAzureLocales(language))
    }
  }, [isLoading, passwordResetRedirect, language])

  return (
    <SpinnerContainer>
      <Spinner size={20} />
    </SpinnerContainer>
  )
}

export default PasswordReset
